"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.is-integer");
require("core-js/modules/es6.number.constructor");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _treatmentsalequantity = require("@/api/treatmentsalequantity");
var _treatmentpartreturn = require("@/api/treatmentpartreturn");
var _org = require("@/api/org");
var _device = require("@/api/device");
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultTreatmentPartReturn = {
  sales_order_no: '',
  return_reason: '',
  directions: '',
  amount: '',
  quantity: '',
  receiving_dept_no: ''
};
var defaultTreatmentShipment = {
  receive_status: null
};
var defaultTreatmentApproval = {
  approval_status: null,
  remark: null
};
var defaultTreatmentPartSaleQuantity = {
  create_time: '',
  create_user_id: '',
  create_user_name: '',
  remark: '',
  approval_time: '',
  approval_user_id: '',
  approval_user_name: '',
  approval_remark: '',
  receiving_time: '',
  receiving_user_id: '',
  receiving_user_name: '',
  receiving_remark: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number(value * 1) && value * 1 !== 0) {
    callBack(new Error('请输入合法的数值'));
  } else {
    if (value * 1 < 0) {
      callBack(new Error('金额不能小于0'));
    } else {
      callBack();
    }
  }
};
var checkNumber1 = function checkNumber1(rule, value, callBack) {
  if (!Number.isInteger(value)) {
    callBack(new Error('请输入合法的整数值'));
  } else {
    if (value < 0) {
      callBack(new Error('数量不能小于0'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  data: function data() {
    return {
      receiving_dept_name: '',
      receiving_time: '',
      receiving_person: '',
      listLoading: true,
      tableData: [],
      treatmentpartreturn: defaultTreatmentPartReturn,
      treatmentshipment: defaultTreatmentShipment,
      treatmentapproval: defaultTreatmentApproval,
      dialogVisible: false,
      approvalDialog: false,
      viewDialog: false,
      viewSaleDialog: false,
      shipmentDialog: false,
      dialogTransformLoading: false,
      transformData: {
        results: []
      },
      dialogTransformLoading1: false,
      transformData1: {
        results: []
      },
      dialogType: 'new',
      number: '',
      rule1: {
        sales_order_no: [{
          required: true,
          message: '请选择销售单号',
          trigger: 'change'
        }],
        return_reason: [{
          required: true,
          message: '请输入退货原因',
          trigger: 'blur'
        }],
        directions: [{
          required: true,
          message: '请输入说明',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '请输入退款金额',
          trigger: 'blur'
        }, {
          validator: checkNumber
        }],
        quantity: [{
          required: true,
          message: '请输入退货数量',
          trigger: 'blur'
        }, {
          validator: checkNumber1
        }],
        receiving_dept_no: [{
          required: true,
          message: '请输入收货部门编号',
          trigger: 'blur'
        }]
      },
      rule2: {
        receive_status: [{
          required: true,
          message: '请选择确认收货状态',
          trigger: 'change'
        }]
      },
      rule3: {
        approval_status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }]
      },
      statusOptions: [{
        value: 1,
        label: '待确认收货'
      }, {
        value: 2,
        label: '待审核'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '完成退款'
      }],
      statusOptions1: [{
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '待发货'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '完成'
      }],
      typeOptions: [{
        value: 1,
        label: '已收货'
      }, {
        value: 2,
        label: '未收货'
      }],
      typeOptions1: [{
        value: 2,
        label: '已收货'
      }, {
        value: 3,
        label: '未收货'
      }],
      approvalOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      listQuery: {
        page: 1,
        page_size: 10
      },
      orgList: [],
      treatmentpartsalequantity: defaultTreatmentPartSaleQuantity,
      dept_name: '新汉方',
      dept_no: 'DZ0001',
      tableText: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      var _this = this;
      this.treatmentpartreturn = Object.assign({}, defaultTreatmentPartReturn);
      this.treatmentpartreturn.receiving_dept_no = this.dept_no;
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs['Form'].clearValidate();
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _treatmentpartreturn.getTreatmentPartReturn)(this.listQuery).then(function (response) {
        if (response.data) {
          // console.log(response.data)
          _this2.tableData = response.data;
          console.log(_this2.tableData.results);
        }
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleEdit: function handleEdit(scope) {
      var _this3 = this;
      this.treatmentpartreturn = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this4 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _treatmentpartreturn.deleteTreatmentPartReturn)(scope.row.id);
            case 2:
              // this.tableData.splice($index, 1)
              _this4.getList();
              _this4.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleView: function handleView(scope) {
      this.transformData.results = [];
      this.viewDialog = true;
      this.dialogTransformLoading = true;
      this.treatmentpartreturn = Object.assign({}, scope.row);
      this.transformData.results.push(this.treatmentpartreturn);
      this.dialogTransformLoading = false;
    },
    handleViewSale: function () {
      var _handleViewSale = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(scope) {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.transformData1.results = [];
              this.treatmentpartsalequantity = Object.assign({}, defaultTreatmentPartSaleQuantity);
              this.viewSaleDialog = true;
              this.dialogTransformLoading1 = true;
              _context2.next = 6;
              return (0, _treatmentsalequantity.getTreatmentPartSaleQuantity)({
                sales_order_no: scope.row.sales_order_no
              }).then(function (res) {
                var arr = res.data.results;
                for (var i = 0; i < res.data.count; i++) {
                  if (arr[i].sales_order_no === scope.row.sales_order_no) {
                    _this5.transformData1.results.push(arr[i]);
                    _this5.treatmentpartsalequantity.create_time = arr[i].create_time;
                    _this5.treatmentpartsalequantity.create_user_id = arr[i].create_user_id;
                    _this5.treatmentpartsalequantity.create_user_name = arr[i].create_user_name;
                    _this5.treatmentpartsalequantity.remark = arr[i].remark;
                    _this5.treatmentpartsalequantity.approval_time = arr[i].approval_time;
                    _this5.treatmentpartsalequantity.approval_user_id = arr[i].approval_user_id;
                    _this5.treatmentpartsalequantity.approval_user_name = arr[i].approval_user_name;
                    _this5.treatmentpartsalequantity.approval_remark = arr[i].approval_remark;
                    _this5.treatmentpartsalequantity.receiving_time = arr[i].receiving_time;
                    _this5.treatmentpartsalequantity.receiving_user_id = arr[i].receiving_user_id;
                    _this5.treatmentpartsalequantity.receiving_user_name = arr[i].receiving_user_name;
                    _this5.treatmentpartsalequantity.receiving_remark = arr[i].receiving_remark;
                  }
                }
              });
            case 6:
              if (this.transformData1.results.length === 0) {
                this.tableText = '暂无数据';
              } else {
                this.tableText = '';
              }
              console.log(this.transformData1);
              this.dialogTransformLoading1 = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleViewSale(_x) {
        return _handleViewSale.apply(this, arguments);
      }
      return handleViewSale;
    }(),
    handleApproval: function () {
      var _handleApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(scope) {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.treatmentpartreturn = Object.assign({}, scope.row);
              this.treatmentapproval = Object.assign({}, defaultTreatmentApproval);
              _context3.next = 4;
              return (0, _user.getUser)(this.treatmentpartreturn.create_by).then(function (response) {
                _this6.treatmentpartreturn.create_by = response.data.name;
              });
            case 4:
              this.approvalDialog = true;
              this.$nextTick(function () {
                _this6.$refs['approvalForm'].clearValidate();
              });
              this.getName();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleApproval(_x2) {
        return _handleApproval.apply(this, arguments);
      }
      return handleApproval;
    }(),
    handleShipment: function handleShipment(scope) {
      var _this7 = this;
      this.treatmentpartreturn = Object.assign({}, scope.row);
      this.treatmentshipment = Object.assign({}, defaultTreatmentShipment);
      this.shipmentDialog = true;
      this.$nextTick(function () {
        _this7.$refs['shipmentForm'].clearValidate();
      });
      this.getName();
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    (0, _treatmentpartreturn.updateTreatmentPartReturn)(_this8.treatmentpartreturn.id, _this8.treatmentpartreturn).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _treatmentpartreturn.createTreatmentPartReturn)(_this8.treatmentpartreturn).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirm(_x3) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    getName: function getName() {
      var _this9 = this;
      console.log(this.treatmentpartreturn.receiving_dept_no);
      this.listQuery.dept_no = this.treatmentpartreturn.receiving_dept_no;
      (0, _org.getOrgList)(this.listQuery).then(function (response) {
        if (response.data) {
          console.log(response.data);
          _this9.receiving_dept_name = response.data[0].name;
        } else {
          _this9.receiving_dept_name = '';
        }
        console.log(_this9.receiving_dept_name);
      });
    },
    getSaleOrder: function getSaleOrder() {
      var _this10 = this;
      if (this.treatmentpartreturn.sales_order_no) {
        (0, _treatmentsalequantity.getTreatmentPartSaleQuantity)({
          sales_order_no: this.treatmentpartreturn.sales_order_no
        }).then(function (response) {
          if (response.data.count === 1) {
            _this10.treatmentpartreturn.amount = response.data.results[0].order_amount;
            _this10.treatmentpartreturn.quantity = response.data.results[0].quantity;
            // this.treatmentpartreturn.receiving_dept_no = response.data.results[0].receiving_medical_no
          } else {
            _this10.treatmentpartreturn.amount = '';
            _this10.treatmentpartreturn.quantity = '';
            // this.treatmentpartreturn.receiving_dept_no = ''
          }
        });
      } else {
        this.treatmentpartreturn.amount = '';
        this.treatmentpartreturn.quantity = '';
        // this.treatmentpartreturn.receiving_dept_no = ''
      }
      console.log(this.treatmentpartreturn.amount);
    },
    confirmApproval: function () {
      var _confirmApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(form) {
        var _this11 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _treatmentpartreturn.approvalTreatmentPartReturn)(_this11.treatmentpartreturn.id, _this11.treatmentapproval).then(function (res) {
                    if (_this11.treatmentapproval.approval_status === 1) {
                      _this11.getList();
                      _this11.approvalDialog = false;
                      _this11.$message({
                        message: '审核通过',
                        type: 'success'
                      });
                    } else if (_this11.treatmentapproval.approval_status === 2) {
                      _this11.getList();
                      _this11.approvalDialog = false;
                      _this11.$message({
                        message: '审核拒绝',
                        type: 'danger'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirmApproval(_x4) {
        return _confirmApproval.apply(this, arguments);
      }
      return confirmApproval;
    }(),
    confirmShipment: function () {
      var _confirmShipment = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this12 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _treatmentpartreturn.receiptTreatmentPartReturn)(_this12.treatmentpartreturn.id, _this12.treatmentshipment).then(function (res) {
                    // this.getList()
                    // this.shipmentDialog = false
                    // this.$message({
                    //   message: '已收货',
                    //   type: 'success'
                    // })
                    if (_this12.treatmentshipment.receive_status === 1) {
                      _this12.getList();
                      _this12.shipmentDialog = false;
                      _this12.$message({
                        message: '已收货',
                        type: 'success'
                      });
                    } else if (_this12.treatmentshipment.receive_status === 2) {
                      _this12.getList();
                      _this12.shipmentDialog = false;
                      _this12.$message({
                        message: '未收货',
                        type: 'danger'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmShipment(_x5) {
        return _confirmShipment.apply(this, arguments);
      }
      return confirmShipment;
    }()
  }
};